import { render, staticRenderFns } from "./payment-button.vue?vue&type=template&id=14ac8268&scoped=true"
import script from "./payment-button.ts?vue&type=script&lang=ts&external"
export * from "./payment-button.ts?vue&type=script&lang=ts&external"
import style0 from "./payment-button.scss?vue&type=style&index=0&id=14ac8268&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ac8268",
  null
  
)

export default component.exports